import { SadaKInput } from './styles';
import { InputProps } from 'antd';

type Props = InputProps;

const KInput = ({ ...props }: Props) => <SadaKInput {...props}></SadaKInput>;

export default KInput;
